module.exports = __webpack_public_path__ + "img/Alitium.2d1bffaa.svg";